import { useEffect, useState } from 'react';
import { Box, Card, Stack, Typography, Input, CircularProgress, Table, Sheet } from '@mui/joy';
import { APIFinanceRewards } from '../../../api';
import { useFinanceToken, MetricCard, SectionCard, scrollTableSx, fmtMoney } from './financeShared';

export default function FinanceRewardsTab() {
  const token = useFinanceToken();
  const now = new Date();
  const [yearFrom, setYearFrom] = useState(now.getFullYear());
  const [monthFrom, setMonthFrom] = useState(1);
  const [yearTo, setYearTo] = useState(now.getFullYear());
  const [monthTo, setMonthTo] = useState(now.getMonth() + 1);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) return;
    setLoading(true);
    APIFinanceRewards(
      { year_from: yearFrom, month_from: monthFrom, year_to: yearTo, month_to: monthTo },
      token,
    )
      .then(setData)
      .catch((e) => console.error('rewards load', e))
      .finally(() => setLoading(false));
  }, [token, yearFrom, monthFrom, yearTo, monthTo]);

  return (
    <Box>
      {/* Период (месяц/год) */}
      <Card variant="soft" color="neutral" sx={{ p: 1, mb: 2, borderRadius: 'xl', bgcolor: 'background.level1', boxShadow: 'none' }}>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ flexWrap: 'wrap', gap: 1 }}>
          <Typography level="body-sm" sx={{ whiteSpace: 'nowrap' }}>Период (мес./год):</Typography>
          <Input type="number" size="sm" value={monthFrom} onChange={(e) => setMonthFrom(e.target.value)}
            sx={{ width: 72, borderRadius: 'lg' }} slotProps={{ input: { min: 1, max: 12 } }} />
          <Input type="number" size="sm" value={yearFrom} onChange={(e) => setYearFrom(e.target.value)} sx={{ width: 96, borderRadius: 'lg' }} />
          <Typography level="body-sm">—</Typography>
          <Input type="number" size="sm" value={monthTo} onChange={(e) => setMonthTo(e.target.value)}
            sx={{ width: 72, borderRadius: 'lg' }} slotProps={{ input: { min: 1, max: 12 } }} />
          <Input type="number" size="sm" value={yearTo} onChange={(e) => setYearTo(e.target.value)} sx={{ width: 96, borderRadius: 'lg' }} />
          {loading && <CircularProgress size="sm" />}
        </Stack>
      </Card>

      <Box sx={{ maxWidth: 360, mb: 2 }}>
        <MetricCard index={0} title="Наработано премий за период" value={fmtMoney(data?.total_earned)} color="#059669" />
      </Box>

      <SectionCard title="По менеджерам">
        <Sheet variant="outlined" sx={{ borderRadius: 'lg', overflow: 'auto' }}>
          <Table borderAxis="both" stickyHeader hoverRow sx={scrollTableSx(420)}>
            <thead>
              <tr>
                <th>Менеджер</th>
                <th style={{ width: 120, textAlign: 'right' }}>Целей</th>
                <th style={{ width: 200, textAlign: 'right' }}>Наработано, ₽</th>
              </tr>
            </thead>
            <tbody>
              {(data?.by_manager || []).map((r) => (
                <tr key={r.manager_id}>
                  <td>{r.manager_name}</td>
                  <td style={{ textAlign: 'right' }}>{r.goals}</td>
                  <td style={{ textAlign: 'right', fontWeight: 600 }}>{fmtMoney(r.earned)}</td>
                </tr>
              ))}
              {(!data?.by_manager || data.by_manager.length === 0) && (
                <tr><td colSpan={3} style={{ textAlign: 'center', color: '#94a3b8' }}>Нет данных за период</td></tr>
              )}
            </tbody>
          </Table>
        </Sheet>
      </SectionCard>
    </Box>
  );
}